import { useAuth } from '../auth/AuthContext';

export function ImpersonationBanner() {
  const { user, impersonator, stopImpersonating } = useAuth();
  if (!impersonator || !user) return null;
  return (
    <div className="imp-banner">
      <span>
        Viewing as <strong>{user.name ?? user.email}</strong> · {user.role}.
        Original session: {impersonator.name}.
      </span>
      <button onClick={stopImpersonating}>Stop impersonating</button>
    </div>
  );
}
